import React from 'react';

import { Task } from '../../../interfaces';
import { TaskForm } from '../TaskForm';
import { useEditTask } from './useEditTask';
import { Favorite } from '@/modules/shared/domain/interfaces';

export function EditTask(props: {
  task?: Task;
  favorite?: Favorite;
  onSuccess?: (taskId?: string) => void;
  onDismiss?: () => void;
}) {
  const { task, favorite, onDismiss } = props;
  const { onSubmit, isSubmiting, defaultValues } = useEditTask(props);
  return (
    <TaskForm
      defaultValues={defaultValues}
      onSubmit={onSubmit}
      onDismiss={onDismiss}
      isLoading={isSubmiting}
      isFavorite={!!favorite}
    />
  );
}
